import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";
import { OptionalOrNull } from "../shared-schemas";

const courseInfoType = Type.Object({
	id: Type.Number(),
	instituteId: Type.Number(),
	courseId: Type.String(),
	code: Type.Optional(Type.Union([Type.String(), Type.Null()])),
	name: Type.Optional(Type.Union([Type.String(), Type.Null()])),
	isBlackboardUltra: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])),
	verityEnabled: Type.Boolean(),
	accessControlUuid: Type.String(),
});

const courseInfo = new SchemaValidator(courseInfoType);
const courseInfoList = new SchemaValidator(Type.Array(courseInfoType));

const accessControlCourseInfoType = Type.Object({
	id: Type.String(),
	instituteId: Type.String(),
	code: OptionalOrNull(Type.String()),
	name: OptionalOrNull(Type.String()),
});
const accessControlCourseInfo = new SchemaValidator(accessControlCourseInfoType);

const courseId = new SchemaValidator(
	Type.Object({
		id: Type.Number(),
	}),
);

const courseCount = new SchemaValidator(
	Type.Object({
		totalElements: Type.Number(),
	}),
);

export default {
	courseInfo,
	courseInfoList,
	accessControlCourseInfo,
	courseId,
	courseCount,
};
